'use client'
import React from 'react';
import { useTranslations } from "next-intl";
import type { Blog } from "@/lib/@types/api/blog";
import { Link } from "@/navigation";
interface TagProps {
	tagList: Blog.BlogTag[];
}
const TagsCloud: React.FC<TagProps> = ({ tagList } ) => {
	const t =useTranslations()
	return (
		<div className="filter-tags md:mt-10 mt-6 h-[500px] overflow-auto">
			<div className="heading6">{t('blog.tags')}</div>
			<div className="list-tags flex items-center flex-wrap gap-3 mt-4">
				{tagList.map((tag) => (
					<Link href={`/tag/${tag.tag_slug}`}
						key={tag.tag_id}
						className={`tags text-gray-600 bg-white border border-line py-1.5 px-3 rounded-full text-button-uppercase text-secondary cursor-pointer duration-300 hover:bg-black hover:text-white `}
					>
						{tag.tag_name}
					</Link>
				))}
			</div>
		</div>
	);
};

export default TagsCloud;
